/** 申请人注册队列、其对话框、批准时的拒绝原因及一次性密码（计划 F3）。 */
export default {
  title: '申请人注册',
  subtitle: '申请申请人账户的顾问。每批准一个将占用一个查看者席位。',
  notPermitted: '只有租户管理员，或经管理员允许的批准人官员，才能审核注册申请。',
  filterLabel: '筛选注册申请',
  status: {
    submitted: '待处理',
    approved: '已批准',
    rejected: '已拒绝',
    superseded: '已被取代',
    expired: '已过期',
    all: '全部',
  },
  statusReason: {
    quota: '此邮箱的申请次数过多',
    stale: '30 天内未审核',
  },
  columns: {
    firm: '公司',
    regNo: '注册编号',
    requested: '申请时间',
  },
  empty: '此处没有注册申请。',
  total: '注册申请：{{total}}',
  approve: '批准',
  reject: '拒绝',
  reviewed: '由 {{name}} 于 {{date}} 审核',
  reason: '理由：{{reason}}',
  approveTitle: '批准此注册申请？',
  approveBody: '{{name}}（{{email}}）将获得一个占用查看者席位的申请人账户。',
  cancel: '取消',
  approvedEmail: '已批准。邀请已发送至 {{email}}。',
  approvedExisting: '已批准。现有账户已加入申请人。',
  approvedPassword: '已批准。请将临时密码交给申请人。',
  identityExistsGuest: '此邮箱的账户已作为访客查看者存在。',
  addToApplicants: '将该账户加入申请人',
  identityExistsOther: '此邮箱的账户已存在且不是访客查看者，因此不能成为申请人。请对方使用其他邮箱注册。',
  emailInUse: '此邮箱属于本服务上另一组织的账户，因此不能在此注册。请申请人使用其他邮箱。',
  roles: {
    admin: '管理员',
    publisher: '发布者',
    viewer: '查看者',
  },
  seatsPurchasable: '所有{{role}}席位均已占用（{{used}}/{{limit}}）。请增加席位后再批准此注册。',
  openBilling: '打开 设置 → 账单',
  seatsAskAdmin: '所有{{role}}席位均已占用（{{used}}/{{limit}}）。请租户管理员增加席位。',
  licencePoolFull: '许可证池已满：所有{{role}}席位（{{used}}/{{limit}}）均已占用。',
  seatsOperator: '所有{{role}}席位均已占用（{{used}}/{{limit}}）。请联系服务运营方增加席位。',
  seatsBusy: '正在创建另一个账户，请稍后重试。',
  notPending: '此注册申请已有决定，列表已刷新。',
  rejectTitle: '拒绝此注册申请？',
  rejectReasonLabel: '理由（申请人可见）',
  rejectReasonRequired: '请输入理由。',
  rejected: '注册申请已拒绝。',
  passwordTitle: '临时密码',
  passwordBody: '请通过可信渠道将此密码交给 {{email}}。对方首次登录时必须修改密码。',
  passwordOnce: '密码仅显示一次，不会保存在任何地方。请立即复制。',
  copy: '复制',
  copied: '已复制',
  passwordDone: '我已复制',
} as const
